var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pricing-plan"},[_c('div',{staticClass:"iq-icon"},[_c('i',{class:_vm.icon,attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('h4',{staticClass:"iq-tw-5"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_vm._t("cardBody")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }